export type Session = {
  token: string;
};

const readHashToken = (): string | null => {
  const hash = window.location.hash.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;

  return new URLSearchParams(hash).get('token');
};

export const readSession = (): Session | null => {
  const token = readHashToken();

  if (!token) {
    return null;
  }

  return { token };
};

export const clearSessionTokenFromHash = () => {
  const nextUrl = `${window.location.pathname}${window.location.search}`;

  window.history.replaceState(null, '', nextUrl);
};
